import {Blog,Features,Footer,Header,Possibility,WhatGPT3} from '../container';
function InoSecure(){
    return (
        <div className='App'>
      
        InoSecure
        </div>
    )
}

export default InoSecure


